import { type InputFieldType } from '@repo/utils';

export const getFormInputFields = `
  query getFormInputFields($formSectionId: ID!) {
    formInputFields(formSectionId: $formSectionId) {
      id
      displayName
      placeholder
      sequenceNumber
      requiredField
      formSectionId
      associate {
        ... on LeadAttribute {
          id
          dataType
          dataTypeConfig {
            dropdownRenderType
          }
          schemaName
        }
      }
    }
  }
`;

export interface GetFormInputFieldType extends Pick<
InputFieldType,
'id' | 'displayName' | 'placeholder' | 'sequenceNumber' | 'requiredField' | 'formSectionId'
| 'associate'> { }

export interface GetFormInputFieldsQuery {
  formInputFields: GetFormInputFieldType[];
}
